import { IconButton } from '@material-ui/core';
import VideoCallIcon from '@material-ui/icons/VideoCall';

const GroupCall = ({meetingId, groupName}) => {

    const handleSubmit = () => {
        const win = window.open(`/virtualroom/meeting/${meetingId}?groupName=${groupName}`, "newwindow");
        win.focus();
    }

    return(
        <div style={{marginLeft:'-1vw'}}>
            <IconButton
            onClick={handleSubmit}>
                <VideoCallIcon
                    color = 'primary'
                    fontSize='inherit'/>
            </IconButton>
            
        </div>

    );
};

export default GroupCall;